import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

// Auto-attach admin token if present
api.interceptors.request.use((config) => {
  const token = typeof window !== "undefined" ? localStorage.getItem("avantech_admin_token") : null;
  if (token && !config.headers.Authorization) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function fetchProducts(category) {
  const params = category ? { category } : {};
  const res = await api.get("/products", { params });
  return res.data;
}

export async function submitContact(payload) {
  const res = await api.post("/contact", payload);
  return res.data;
}

// Admin
export async function adminStats() {
  return (await api.get("/admin/stats")).data;
}
export async function adminListContacts() {
  return (await api.get("/admin/contacts")).data;
}
export async function adminDeleteContact(id) {
  return (await api.delete(`/admin/contacts/${id}`)).data;
}
export async function adminCreateProduct(payload) {
  return (await api.post("/admin/products", payload)).data;
}
export async function adminUpdateProduct(id, payload) {
  return (await api.put(`/admin/products/${id}`, payload)).data;
}
export async function adminDeleteProduct(id) {
  return (await api.delete(`/admin/products/${id}`)).data;
}
export async function adminUploadImage(file) {
  const fd = new FormData();
  fd.append("file", file);
  const res = await api.post("/admin/upload", fd, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return res.data; // { url, filename, size }
}

/**
 * Convert a relative image URL ("/api/uploads/xxx.png") to an absolute one
 * pointing at the backend, leaving full URLs untouched.
 */
export function resolveImage(url) {
  if (!url) return url;
  if (url.startsWith("/api/uploads/") || url.startsWith("/uploads/")) {
    // Support both legacy "/uploads/" and current "/api/uploads/"
    const path = url.startsWith("/api/") ? url : `/api${url}`;
    return `${BACKEND_URL}${path}`;
  }
  return url;
}
